import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/services/common-services/common.service';
import { environment } from 'src/environments/environment';
import * as EmailValidator from 'email-validator';
import { noNumericAfterDotComValidator } from 'src/app/shared/numeric-after-dot-validator';

import { ToastrService } from 'ngx-toastr';
import { ConfirmationBoxComponent } from 'src/app/shared/elements/confirmation-box/confirmation-box.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-pre-login',
  templateUrl: './pre-login.component.html',
  styleUrls: ['./pre-login.component.scss'],
})
export class PreLoginComponent {
  preLogin!: FormGroup;
  baseUrl = environment.BASE_URL;
  portalUrl = environment.PORTAL_URL;
  userStatus: any;
  redirectEmail: any;
  userType: any;
  redirectTo: any;
  event: any;
  urlParams: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private service: CommonService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.event = params['name'];
      if (this.event) {
        localStorage.setItem('event', this.event);
      }

      this.redirectEmail = params['email'];
      this.userType = params['userType'];
      this.redirectTo = params['redirectTo'];
    });

    this.preLogin = this.fb.group({
      email: [
        '',
        [Validators.required, Validators.email, noNumericAfterDotComValidator()],
      ],
    });

    //this.setData();
    this.getData();
    // console.log(this.urlParams)

    this.preLogin = this.fb.group({
      email: [
        this.redirectEmail || '',
        [Validators.required, Validators.email, noNumericAfterDotComValidator()],
      ],
    });

    if (this.redirectEmail && this.userType && this.redirectTo) {
      this.preSubmit();
    }
  }

  // setData(): void {
  //   this.service.setUrlParams(this.redirectEmail, this.redirectTo, this.userType);
  // }
  getData() {
    return (this.urlParams = this.service.getUrlParams());
  }
  get validateEmail() {
    return EmailValidator.validate(this.preLogin.value.email);
  }
  isValid() {
    if (this.preLogin.controls['email'].status === 'INVALID') {
      return true;
    } else {
      return false;
    }
  }
  preSubmit() {
    const email = this.preLogin.value.email.toLowerCase();
    this.service
      .getData(
        `${this.baseUrl}auth-service/user-management/getUserDetailByEmail?emailId=${email}`,
      )
      .subscribe({
        next: (res: any) => {
          this.userStatus = res?.response;
          if (this.userStatus.userExist == true) {
            localStorage.removeItem('preEmail');
            localStorage.setItem('preEmail', this.preLogin.value.email);
            if (this.userStatus.userType === 'Customer') {
              this.router.navigate(['/login']);
            } else if (this.userStatus.userType === 'Supplier') {
              let redirectUrl:any = `${this.portalUrl}supplier/login?email=${this.preLogin.value.email}`;
              this.openRedirectionConfirmation(redirectUrl);
              //window.open(`${this.portalUrl}supplier/login?email=${this.preLogin.value.email}`, '_blank');
            }
            this.preLogin.reset();
          } else {
            localStorage.removeItem('preEmail');
            this.toastr.error('User does not exist');
          }
        },
        error: (e) => {
          if (e.error?.status?.error?.message) {
            this.toastr.error(e.error.status.error.message);
          }
        },
      });
  }

  openRedirectionConfirmation(redirectUrl:string){
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        cssClass: 'redirectCnt',
        content: `You are being redirected to Unibuild Supplier Portal.`,
        btnConfirm: 'OK',
        btnCancel: 'Cancel',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        //console.log(result, "Result");
        window.open(redirectUrl, '_blank');
      } 
    });
  }
}
